(() => {
  const THRESHOLD_CENTS = 2900; // matches the Shopify and Loop shipping rates
  const COPY_LOCKED = "You're 1 box away from free shipping";
  const COPY_UNLOCKED = 'Free shipping unlocked';

  let container = null;
  let textEl = null;
  let fillEl = null;
  let trackEl = null;
  let inflight = null;

  function cacheRefs() {
    container = document.querySelector('[data-progress-bar]');
    if (!container) return false;
    textEl = container.querySelector('[data-progress-text]');
    fillEl = container.querySelector('[data-progress-fill]');
    trackEl = container.querySelector('[role="progressbar"]');
    return true;
  }

  function setText(newText) {
    if (!textEl) return;
    if (textEl.textContent.trim() === newText) return;
    /* Instant swap — no fade. The previous fade-out → setTimeout → swap → fade-in
       sequence could double-fire on rapid +/- clicks, leaving old and new text
       visually overlapping on mobile. The fill width transition (400ms linear) is
       the visual cue; the label just needs to be correct. */
    textEl.textContent = newText;
  }

  function render(cart) {
    if (!container) return;

    const itemCount = cart.item_count || 0;
    if (itemCount === 0) {
      container.hidden = true;
      return;
    }
    container.hidden = false;

    const subtotal = cart.total_price || 0; // discounted total, as Shopify uses for the rate
    const progress = Math.min(100, (subtotal / THRESHOLD_CENTS) * 100);
    const unlocked = subtotal >= THRESHOLD_CENTS;

    if (fillEl) fillEl.style.width = progress + '%';
    if (trackEl) trackEl.setAttribute('aria-valuenow', String(Math.floor(progress)));

    setText(unlocked ? COPY_UNLOCKED : COPY_LOCKED);
    container.classList.toggle('cart-drawer__progress--unlocked', unlocked);
  }

  async function refresh() {
    /* Coalesce overlapping requests — multiple cart events can fire in quick
       succession (e.g. upgrade flow chains change.js + sections fetch). */
    if (inflight) return inflight;
    inflight = (async () => {
      try {
        const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('cart fetch failed: ' + res.status);
        const cart = await res.json();
        if (!container && !cacheRefs()) return;
        render(cart);
      } catch (err) {
        console.error('[SC progress bar] refresh failed:', err);
      } finally {
        inflight = null;
      }
    })();
    return inflight;
  }

  function init() {
    if (!cacheRefs()) return;
    if (window.eventBus && typeof window.eventBus.on === 'function') {
      window.eventBus.on('update:cart:drawer', refresh);
      window.eventBus.on('render:cart:drawer', refresh);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
